var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import CardBody from '../../card/CardBody';
import CardFooter from '../../card/CardFooter';
import CardHeader from '../../card/CardHeader';
import { Modal } from '../../modal';
import FormFeedback from '../FormFeedback';
import FormComponent from '../formComponent/FormComponent';
import { Button } from '../../button';
/*
 * Форма для подтверждения выполнения какой-либо операции
 */
var ConfirmForm = /** @class */ (function (_super) {
    __extends(ConfirmForm, _super);
    function ConfirmForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, action, isCloseAfterSubmit;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, action = _a.action, isCloseAfterSubmit = _a.isCloseAfterSubmit;
                        return [4 /*yield*/, action()];
                    case 1:
                        _b.sent();
                        if (isCloseAfterSubmit) {
                            this.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onClose = function () {
            var onCloseForm = _this.props.onCloseForm;
            _this.setState({
                isSendingRequest: false,
                sendingError: null,
                isSendingSuccess: false,
            });
            onCloseForm();
        };
        _this.state = {
            isSendingRequest: false,
            isCloseAfterSubmit: _this.props.isCloseAfterSubmit,
        };
        return _this;
    }
    ConfirmForm.prototype.componentWillUnmount = function () {
        this.setState({
            isSendingRequest: false,
            sendingError: null,
            isSendingSuccess: false,
        });
        _super.prototype.componentWillUnmount.call(this);
    };
    ConfirmForm.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, header = _a.header, body = _a.body, submitButtonText = _a.submitButtonText, onSuccessMessage = _a.onSuccessMessage, onCloseForm = _a.onCloseForm;
        var isSendingSuccess = this.state.isSendingSuccess;
        return (React.createElement(Modal, { size: 'sm', isOpen: isOpen, onClose: onCloseForm },
            React.createElement("form", { onSubmit: this.onSubmit },
                React.createElement(CardHeader, null, header),
                React.createElement(CardBody, null,
                    body,
                    this.getErrorFormFeedback('mt-primary mb-0'),
                    isSendingSuccess && (React.createElement(FormFeedback, { valid: true, className: 'mt-primary mb-0' }, onSuccessMessage))),
                React.createElement(CardFooter, { className: 'text-right' },
                    React.createElement(Button, { size: 'sm', type: 'button', color: 'primary', outline: true, onClick: this.onClose }, isSendingSuccess ? 'Закрыть' : 'Отмена'),
                    React.createElement(Button, { size: 'sm', type: 'submit', color: 'primary', className: 'ml-primary', disabled: this.isSubmitDisabled() }, submitButtonText)))));
    };
    return ConfirmForm;
}(FormComponent));
export default ConfirmForm;
//# sourceMappingURL=ConfirmForm.js.map